// extracted by mini-css-extract-plugin
module.exports = {"map":"CompetitorMap_map__3P6a3"};